import * as RadixTooltip from "@radix-ui/react-tooltip";
import { ReactNode } from "react";
import { motion } from "framer-motion";
import styled from "styled-components";

// The pill shape only suits a single line; several lines get a regular box.
const StyledTooltipContent = styled(motion.div)<{ $isMultiline?: boolean }>`
  padding-left: ${(props) => props.theme.space[4]};
  padding-right: ${(props) => props.theme.space[4]};
  padding-top: ${(props) => props.theme.space[props.$isMultiline ? 2 : 1]};
  padding-bottom: ${(props) => props.theme.space[props.$isMultiline ? 2 : 1]};
  font-size: ${(props) => props.theme.fontSizes.xs};
  background-color: ${(props) => props.theme.tooltipBackgroundColor};
  color: ${(props) => props.theme.tooltipTextColor};
  border-radius: ${(props) =>
    props.$isMultiline ? props.theme.borderRadius : "100px"};
  border: 1px solid;
  border-color: ${(prosp) => prosp.theme.borderColor};
  box-shadow: ${(props) => props.theme.shadows["2xl"]};
`;

export const Tooltip = ({
  children,
  content,
  asChild = false,
  isDisabled,
  triggerClassNames,
  side = "top",
  isMultiline,
}: {
  asChild?: boolean;
  isDisabled?: boolean;
  children: ReactNode;
  content: ReactNode;
  triggerClassNames?: string;
  side?: "top" | "right" | "bottom" | "left";
  isMultiline?: boolean;
}) => {
  return (
    <RadixTooltip.Provider delayDuration={0}>
      <RadixTooltip.Root>
        <RadixTooltip.Trigger
          asChild={asChild}
          {...(isDisabled && {
            onPointerMove: (event) => event.preventDefault(),
            onFocus: (event) => event.preventDefault(),
          })}
          className={triggerClassNames}
        >
          {children}
        </RadixTooltip.Trigger>
        <RadixTooltip.Portal>
          <RadixTooltip.Content side={side}>
            <StyledTooltipContent
              $isMultiline={isMultiline}
              initial={{ opacity: 0, scale: 0.85 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.25 }}
            >
              {content}
            </StyledTooltipContent>
          </RadixTooltip.Content>
        </RadixTooltip.Portal>
      </RadixTooltip.Root>
    </RadixTooltip.Provider>
  );
};
